module.exports = __webpack_public_path__ + "static/media/4_happyhorse_textil.ce1ef36e.jpg";